  <template>
    <div class="contentbox">
      <div class="top-search">
        <el-form :inline="true" :model="formInline" ref="formInline" size="small" class="demo-form-inline">
          <!--<el-form-item label="小程序" prop="appid" v-if="!isAgent">-->
            <!--<app-list @getAppId="getAppId" :appId="formInline.appId" clear="noclear"></app-list>-->
          <!--</el-form-item>-->
          <!-- format="yyyy-MM-dd HH:mm:ss"
							value-format="yyyy-MM-dd HH:mm:ss"
							type="datetimerange" -->
          <!-- format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
          type="daterange" -->
          <el-form-item label="日期：">
						<el-date-picker
							v-model="dataTime"
							class="pickerData"
							format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              type="datetimerange"
							unlink-panels
							range-separator="至"
							start-placeholder="开始日期"
							end-placeholder="结束日期" style="margin-right: 10px; width: 400px" clearable @change="search">
						</el-date-picker>
					</el-form-item>
          <el-form-item label="短剧名" prop="svName">
            <el-input v-model="formInline.svName" placeholder="请输入短剧名" clearable @keyup.enter.native="search"
              @clear="search" style="width: 180px;"></el-input>
          </el-form-item>
          <el-form-item label="投放链接ID" prop="tfid">
            <el-input v-model="formInline.tfid" placeholder="请输入投放链接ID" clearable @keyup.enter.native="search"
              @clear="search" style="width: 180px;"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
          </el-form-item>
          <el-form-item>
            <el-button icon="el-icon-refresh" @click="resetQuery">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="tableTh" v-height>
				<el-table :data="tableData.result" border stripe style="width: 100%" height="100%" class="tableStyle" v-loading="loading">
					<el-table-column prop="svName" label="短剧信息" width="250" fixed>
						<template slot-scope="scope">
							<div class="td-info">
								<p>短剧名：{{scope.row.svName}}</p>
								<p>别名：{{scope.row.aliasName}}</p>
								<p>短剧ID：{{scope.row.svId}}</p>
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="userNumber" label="观剧总用户数" width="120"></el-table-column>
          <el-table-column prop="rechargeUserNumber" label="充值人数">
            <template slot-scope="scope">
							<div class="td-info">
								<p>{{scope.row.rechargeUserNumber || 0}}</p>
							</div>
						</template>
          </el-table-column>
          <el-table-column prop="payRate" label="付费率" width="120" v-if="roleName != '版权商'">
            <template slot="header">
              <el-tooltip class="item" effect="dark" content="付费率=充值人数/观剧总用户数" placement="top">
                <p>付费率</p>
              </el-tooltip>
            </template>
            <template slot-scope="scope">
							<div class="td-info">
								<p v-if="scope.row.userNumber == 0">0.00%</p>
								<p v-else>{{ (((+scope.row.rechargeUserNumber) / (+scope.row.userNumber)) * 100).toFixed(2) || 0}}%</p>
							</div>
						</template>
          </el-table-column>
          <el-table-column prop="recharge" label="充值金额" v-if="roleName != '版权商'">
            <template slot-scope="scope">
							<div class="td-info">
								<p>{{scope.row.recharge || 0}}</p>
							</div>
						</template>
          </el-table-column>
					<el-table-column prop="adClickNumber" label="广告总点击数" width="120" v-if="roleName != '版权商'"></el-table-column>
					<el-table-column prop="adPlayNumber" label="广告总完播数" width="120" v-if="roleName != '版权商'"></el-table-column>
					<el-table-column prop="adAverageRate" label="人均广告完播数" width="120" v-if="roleName != '版权商'">
            <template slot="header">
              <el-tooltip class="item" effect="dark" content="人均广告完播数=广告总完播数/总用户数" placement="top">
                <p>人均广告完播数</p>
              </el-tooltip>
            </template>
          </el-table-column>
					<el-table-column prop="adPlayEcpmNumber" label="有ECPM广告数"  width="120" v-if="roleName != '版权商'"></el-table-column>
					<el-table-column prop="userEcpmNumber" label="有ECPM用户数" width="120" v-if="roleName != '版权商'"></el-table-column>
					<el-table-column prop="ecpmUserRate" label="ECPM用户比" width="120" v-if="roleName != '版权商'">
            <template slot="header">
              <el-tooltip class="item" effect="dark" content="ECPM用户比=有ECPM用户数/总用户数" placement="top">
                <p>ECPM用户比</p>
              </el-tooltip>
            </template>
            <template slot-scope="scope">
							<div class="td-info">
								<p v-if="scope.row.ecpmUserRate">{{(scope.row.ecpmUserRate * 100).toFixed(2)}}%</p>
								<p v-else>0.00%</p>
							</div>
						</template>
          </el-table-column>
					<el-table-column prop="userPlayAverageRate" label="人均观看集数" width="120" v-if="roleName != '版权商'">
            <template slot="header">
              <el-tooltip class="item" effect="dark" content="人均观看集数=总观看集数/总用户数" placement="top">
                <p>人均观看集数</p>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column prop="adShareIncome" label="广告分成收入（元）" width="150" v-if="roleName === '版权商' || roleName === '超级管理员'">
            <template slot="header">
              <el-tooltip class="item" effect="dark" content="广告分成收入=该剧广告收入*分成比例" placement="top">
                <p>广告分成收入（元）</p>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column prop="rechargeShareIncome" label="充值分成收入（元）" width="150" v-if="roleName === '版权商' || roleName === '超级管理员'">
            <template slot="header">
              <el-tooltip class="item" effect="dark" content="充值分成收入=该剧充值收入*分成比例" placement="top">
                <p>充值分成收入（元）</p>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column prop="totalIncome" label="总收入（元）" width="120" v-if="roleName === '版权商' || roleName === '超级管理员'"></el-table-column>
					<el-table-column prop="haveEcpmArpu" label="arpu平均值" width="150">
            <template slot="header">
              <el-tooltip class="item" effect="dark" content="arpu平均值=cost之和/100000/对应用户数" placement="top">
                <p>arpu平均值</p>
              </el-tooltip>
            </template>
            <template slot-scope="scope">
							<div class="td-info">
								<p>有ECPM用户：{{scope.row.haveEcpmArpu}}</p>
								<p>总用户：{{scope.row.arpu}}</p>
							</div>
						</template>
          </el-table-column>
					<el-table-column label="操作" width="100" fixed="right">
						<template slot-scope="scope" class="ddd">
							<el-button type="defult" icon="el-icon-warning-outline" size="mini" @click="handleLook(scope.row)">查看</el-button>
						</template>
					</el-table-column>
				</el-table>
				<div class="foot-table" style="text-align:center;">
					<el-pagination
							@current-change="handleCurrentChange"
							@size-change="handleSizeChange"
							:page-sizes="[20, 50, 100, 200, 500]"
							:page-size="tableData.pageSize"
							background
							:current-page="currentPage"
							layout="sizes, prev, pager, next, jumper, ->, total"
							:total="tableData.totalNum">
					</el-pagination>
				</div>
			</div>
      <!-- 查看 -->
      <loss-table :visible.sync="dialogInfoVisible"  @cancelDialogApp="cancelDialogApp" :videoInfo="videoInfo" :tfid="tfid" :Time="dataTime"></loss-table>

    </div>
  </template>
  <script>
  import { list } from "@/api/dysvzk/data/videodaily";
  // import AppList from '@/components/AppList'
  import LossTable from '@/components/LossTable'
  export default {
    components: {
      // AppList,
      LossTable
    },
    data() {
      return {
        dataTime: [],
        loading: true,
        formInline: {
          svName: '',
          tfid: '',
          startTime: '',
          endTime: '',
          appId: localStorage.getItem('appId'),
        },
        tableData: {
          pageSize: 20,
          pageNo: 1,
          totalPage: 1,
          totalNum: 0,
          result: [
          ]
        },
        currentPage: 1,
        isAgent:false,
        dialogInfoVisible:false,
        videoInfo:null,
        tfid:'',
        roleName:JSON.parse(localStorage.getItem('accountInfo')).roleName
      }
    },
    computed: {},
    watch: {
    },
    mounted: function () {
      if(JSON.parse(localStorage.getItem('accountInfo')).bangdingAppId){
				this.isAgent = true
        this.formInline.appId = JSON.parse(localStorage.getItem('accountInfo')).bangdingAppId
			}
      this.getTableData()
    },
    methods: {
      // 从组件获取appid
      getAppId(data) {
        this.formInline.appId = data
        this.getTableData()
      },
      search () {
        this.loading = true
        this.currentPage = 1
        this.getTableData()
      },
      resetQuery: function(){
        this.loading = true
        this.$refs['formInline'].resetFields()
        this.dataTime = []
        this.getTableData()
      },
      handleCurrentChange(value) {
        this.currentPage = value
        this.getTableData()
      },
      handleSizeChange (val) {
        this.tableData.pageSize  = val
        this.currentPage = 1
        this.getTableData()
      },
      //点击查看分析
      handleLook(row) {
        console.log("rrrr",row)
        this.videoInfo = row
        this.tfid = this.formInline.tfid
        this.dialogInfoVisible = true
      },
      //获取列表
      getTableData() {
        let json2 = {
          pageNo: this.currentPage,
          pageSize: this.tableData.pageSize
        };
        this.formInline.startTime = this.dataTime ? this.dataTime[0] : ''
        this.formInline.endTime = this.dataTime ? this.dataTime[1] : ''
        let json1 = this.formInline;
        let paramJson = { ...json1, ...json2 };
        list(paramJson).then(response => {
          this.loading = false
          if (response.data.head.flag === 0) {
            this.tableData = response.data.content
          } else {
            this.$message.error(response.data.head.desc)
          }

        });
      },
      cancelDialogApp(){
        this.dialogInfoVisible = false
      }

    } 
  }
  </script>
